(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-partner/assets/react/pages/physical-tickets/constants.js') >= 0) return;  svs.modules.push('/modules/ticket-partner/assets/react/pages/physical-tickets/constants.js');

const names = {
  MESSAGE: 'message',
  ADRESS_OTHER: 'deliveryAddress',
  DELIVER_DATE_LATEST: 'deliverLatest'
};

const FORMS = {
  HEADER: 'Beställ fysiska lotter',
  COMPANY_SECTION_HEADER: 'Företag',
  CONTACT_SECTTION_HEADER: 'Kontaktperson',
  BILLING_SECTION_HEADER: 'Faktureringsadress',
  ORDER_LABEL: 'Beställ',
  MINIMUM_AMOUNT: 0,
  MINIMUM_AMOUNT_ERROR_MESSAGE: 'Minibelopp för första beställningen är 1 500 kr.',
  SELECT_PHYSICAL_TICKETS: {
    SUM: {
      SUM: 'Summa:',
      SEK: 'kr',
      FOOTNOTE: '* Trisspaket innehåller 3 st MiniTriss, 2 st Triss och 1 st DubbelTriss'
    }
  },
  DELIVERY_INFO: 'Vår distribution kan hjälpa er att paketera och skicka ut lotter i alla volymer enligt specifika önskemål. Välkomna att kontakta oss för ytterligare information och prisuppgifter.',
  DELIVER_DATE_LATEST: {
    DELIVER_DATE_LATEST_LABEL: 'Levereras senast'
  },
  ADRESS_OTHER: {
    ADRESS_OTHER_LABEL: 'Leveransadress (om annan än ovanstående)',
    ADRESS_OTHER_MAX: 500,
    ADRESS_OTHER_MAX_ERROR: '',
    ADRESS_OTHER_ROWS: 6
  },
  MESSAGE: {
    MESSAGE_LABEL: 'Eventuellt meddelande (valfritt)',
    MESSAGE_MAX: 500,
    MESSAGE_MAX_ERROR: '',
    MESSAGE_ROWS: 4
  }
};

svs.ticket_partner.physicalTickets.constants = {
  FORMS,
  names
};


 })(window);